var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2883",
    "data-name": "Group 2883",
    transform: "translate(-249 -2280)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1312",
    "data-name": "Rectangle 1312",
    width: 24,
    height: 24,
    transform: "translate(249 2280)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(250 2283.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2327",
    "data-name": "Group 2327",
    transform: "translate(0 -2.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M-1.326-8.749A2.882,2.882,0,0,1-3.5-9.737a2.9,2.9,0,0,1-.685-2.3A10.675,10.675,0,0,1-2.2-17.222a6.756,6.756,0,0,1,2.591-2.05A4.807,4.807,0,0,1-1.3-22.941a4.8,4.8,0,0,1,1.493-3.5,4.8,4.8,0,0,1,3.562-1.336A4.852,4.852,0,0,1,8.362-23.1a4.858,4.858,0,0,1-1.683,3.826,6.668,6.668,0,0,1,1.669,1.061.561.561,0,0,1,.055.791.56.56,0,0,1-.384.192.56.56,0,0,1-.407-.136A5.659,5.659,0,0,0,5.3-18.577a.56.56,0,0,1-.418-.484.561.561,0,0,1,.308-.561A3.729,3.729,0,0,0,7.24-23.069,3.725,3.725,0,0,0,3.7-26.656a3.682,3.682,0,0,0-2.74,1.028A3.681,3.681,0,0,0-.185-22.941a3.7,3.7,0,0,0,2.066,3.325.562.562,0,0,1,.308.56.56.56,0,0,1-.417.484c-2.663.691-4.34,3-4.846,6.686a1.776,1.776,0,0,0,.421,1.412,1.759,1.759,0,0,0,1.327.6h0l5,0h0a.561.561,0,0,1,.561.56.561.561,0,0,1-.56.561Z",
    transform: "translate(4.21 27.781)",
    fill: "#6db3e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2327-2",
    "data-name": "Group 2327",
    transform: "translate(11.548 -3.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1880-2",
    "data-name": "Path 1880",
    d: "M12.414-27.269a8.415,8.415,0,0,1,2.379-.5A4.852,4.852,0,0,1,19.4-23.1a4.858,4.858,0,0,1-1.683,3.826,6.668,6.668,0,0,1,1.669,1.061.561.561,0,0,1,.055.791.56.56,0,0,1-.384.192.56.56,0,0,1-.407-.136,5.659,5.659,0,0,0-2.318-1.206.56.56,0,0,1-.418-.484.561.561,0,0,1,.308-.561,3.729,3.729,0,0,0,2.055-3.448,3.725,3.725,0,0,0-3.539-3.586,7.438,7.438,0,0,0-1.324.176Z",
    transform: "translate(-12.414 27.771)",
    fill: "#6db3e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2328",
    "data-name": "Group 2328",
    transform: "translate(9.492 8.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M-2.167-5.417a.562.562,0,0,1-.548-.445l-.232-1.1a4.624,4.624,0,0,1-1.182-.685L-5.2-7.292a.561.561,0,0,1-.661-.249L-6.8-9.175a.56.56,0,0,1,.11-.695l.834-.754a4.639,4.639,0,0,1-.053-.685,4.633,4.633,0,0,1,.051-.685l-.836-.744a.561.561,0,0,1-.112-.695l.941-1.637a.56.56,0,0,1,.659-.253l1.07.349a4.626,4.626,0,0,1,1.18-.685l.229-1.1a.56.56,0,0,1,.548-.445H-.294a.561.561,0,0,1,.548.445l.232,1.1a4.6,4.6,0,0,1,1.182.685l1.069-.351a.56.56,0,0,1,.66.252l.945,1.626a.56.56,0,0,1-.109.7l-.834.754a4.622,4.622,0,0,1,.053.685h0a4.619,4.619,0,0,1-.051.685l.836.739a.561.561,0,0,1,.112.7L3.406-7.553a.56.56,0,0,1-.659.253l-1.07-.349A4.614,4.614,0,0,1,.5-6.963l-.229,1.1a.56.56,0,0,1-.548.445ZM-4-8.833a.56.56,0,0,1,.378.147A3.518,3.518,0,0,0-2.3-7.915a.559.559,0,0,1,.38.419l.206.959h.976l.2-.959a.562.562,0,0,1,.38-.42A3.523,3.523,0,0,0,1.175-8.69a.56.56,0,0,1,.553-.12l.936.3.484-.847-.732-.655a.56.56,0,0,1-.173-.538,3.554,3.554,0,0,0,.085-.77,3.558,3.558,0,0,0-.087-.77.562.562,0,0,1,.173-.538l.73-.656-.489-.844-.935.307a.56.56,0,0,1-.554-.119,3.518,3.518,0,0,0-1.331-.772.559.559,0,0,1-.38-.419l-.206-.959h-.976l-.2.959a.562.562,0,0,1-.38.42,3.514,3.514,0,0,0-1.329.774.56.56,0,0,1-.553.12l-.933-.306-.487.845.731.655a.56.56,0,0,1,.174.538,3.555,3.555,0,0,0-.086.771,3.558,3.558,0,0,0,.087.771A.562.562,0,0,1-4.874-10l-.73.656.491.843.936-.307A.548.548,0,0,1-4-8.835",
    transform: "translate(6.881 17.2)",
    fill: "#6db3e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2329",
    "data-name": "Group 2329",
    transform: "translate(12.921 12.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M-1.016-2.033a2.192,2.192,0,0,1-1.561-.646,2.2,2.2,0,0,1-.649-1.562A2.2,2.2,0,0,1-2.581-5.8a2.2,2.2,0,0,1,1.565-.649h0a.561.561,0,0,1,.56.56.561.561,0,0,1-.56.561,1.082,1.082,0,0,0-.77.32,1.08,1.08,0,0,0-.319.771,1.08,1.08,0,0,0,.32.771,1.083,1.083,0,0,0,.769.317h0a1.08,1.08,0,0,0,.771-.317,1.079,1.079,0,0,0,.318-.773.562.562,0,0,1,.56-.562h0a.561.561,0,0,1,.56.56A2.192,2.192,0,0,1,.548-2.682,2.192,2.192,0,0,1-1.016-2.033Z",
    transform: "translate(3.227 6.454)",
    fill: "#6db3e0"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.846d1014aca3a071ed967a5de1db92da.svg";
export { ForwardRef as ReactComponent };